import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import DropdownItem from "react-bootstrap/esm/DropdownItem";
import { withTranslation } from "react-i18next";
import {
	BiDotsHorizontalRounded,
	BiPencil,
	BiTrash
} from "react-icons/bi";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Utils from "../../../core/utilities/Utils";
import { GDQuestionCategory, LS_AUTHORITY_KEY, USER_ROLE } from "../../../core/constants/common";
import GeneralDisclosureService from "../../../core/service/GeneralDisclosureService";
import ConfirmDialog from '../../../core/utilities/ConfirmPopup';
import "./../Standards/Metric/Metric.scss";
import GDQuestionFormPopup from "./GDQuestionFormPopup";
import GDQuestionFormAdminPopup from "./GDQuestionFormAdminPopup";
import useHasPermission from "../../../core/hooks/useHasPermission";


const GDQuestionList = ({
	t,
}) => {
	const authority = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
	const navigate = useNavigate();
	const { gd_id } = useParams();
	const [disclosure, setDisclosure] = useState({});
	const [selectedQuestion, setSelectedQuestion] = useState({});
	const [showQuestionFormPopup, setShowQuestionFormPopup] = useState(false);
	const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
	const { hasDMOneTimeViewPermission } = useHasPermission();

	useEffect(() => {
		getDisclosure();
	}, []);

	const getDisclosure = () => {
		GeneralDisclosureService.getDisclosure(gd_id, true, authority.roles.includes(USER_ROLE.SUPER_ADMIN))
			.then((response) => {
				if (response.status !== 200) return;

				const disclosureData = response.data;
				disclosureData.questions = response.data.questions?.sort((a, b) => a.sortOrder - b.sortOrder);
				setDisclosure(response.data);
			})
			.catch((error) => { });
	};

	const onAdd = () => {
		setSelectedQuestion({});
		setShowQuestionFormPopup(true);
	};

	const onDelete = (id) => {
		setShowDeleteConfirmation(true);
		setSelectedQuestion({ id: id });
	};
	const onEdit = (q) => {
		setSelectedQuestion(q);
		setShowQuestionFormPopup(true);
	};

	const onSave = () => {
		getDisclosure();
		setShowQuestionFormPopup(false);
	};

	const onDeleteConfirm = () => {
		GeneralDisclosureService.deleteQuestion(gd_id, selectedQuestion.id, authority.roles.includes(USER_ROLE.SUPER_ADMIN))
			.then((response) => {
				setShowDeleteConfirmation(false);
				if (response.status !== 200) return;

				toast.success("Success", {
					position: toast.POSITION.TOP_RIGHT,
				});
				getDisclosure();
			})
			.catch((error) => {
				setShowDeleteConfirmation(false);
			});
	};

	return (
		<>
			<div className="List_header pb-2">
				<h5 className="MH m-0">{t("Configurations.label")}</h5>
			</div>
			<div className="Topics_headeView">
				<ul>
					<li>
						{t('UniversalStandard.label')} : <b>{disclosure?.name}</b>
					</li>
				</ul>
				{
					authority.roles.includes("SUPER_ADMIN") &&
					<div className="btn-custom p-1 text-end">
						<button
							className="btn btn-secondary me-2"
							onClick={() => navigate('/admin/disclosures')}>
							{t("Back.label")}
						</button>
						<button
							className="btn btn-primary"
							onClick={() => onAdd()}>
							{t("AddQuestion.label")}
						</button>
					</div>
				}
			</div>
			{
				disclosure?.questions?.map((question, index) => (
					<div className="card StandardAddMetric_Card" key={`discQuestion-${index + 1}`} id={`discQuestion-${index + 1}`}>
						<div className="card-body px-2 py-1">
							<div className="row m-0">
								<div className="col-lg-12 p-0">
									<div className="row m-0">
										<div className="col-lg-10 p-2">
											<h6 className="mb-0 me-2">{question?.name}</h6>
											<h6 className="m-0 text-muted">{question?.helpText}</h6>
										</div>
									</div>
									<div className="row m-0">
										<div className="col-lg-3 p-2">
											<ul>
												<li>
													<p className="mb-0">{t("Category.label")} : </p>
													<h6 className="mb-0">{GDQuestionCategory({ t })?.find(c => c.value === question?.category)?.label ?? ''}</h6>
												</li>
											</ul>
										</div>
										<div className="col-lg-3 p-2">
											<ul>
												<li>
													<p className="mb-0">{t("Code.label")} : </p>
													<h6 className="mb-0">{question?.code}</h6>
												</li>
											</ul>
										</div>
									</div>
									{
									   hasDMOneTimeViewPermission() &&
										//authority.roles.includes("SUBSCRIBER_ADMIN") &&  //DOUBT
										<div className="row m-0">
											<div className="col-lg-12 p-2">
												<ul>
													<li>
														<p className="mb-0">{t("Answer.label")} : </p>
														<h6 className="mb-0">{question?.answer}</h6>
													</li>
												</ul>
											</div>
										</div>
									}
								</div>
							</div>
							<div className="edit_btn-absolute">
								<Dropdown>
									<Dropdown.Toggle variant="blank_outline" id="dropdown-basic">
										<BiDotsHorizontalRounded />
									</Dropdown.Toggle>
									<Dropdown.Menu>
										<Dropdown.Item
											href="#"
											onClick={() => onEdit(question)} >
											<BiPencil /> {t("Edit.label")}
										</Dropdown.Item>
										{
											authority.roles.includes("SUPER_ADMIN") &&
											<DropdownItem onClick={() => onDelete(question.id)} >
												<BiTrash /> {t("Delete.label")}
											</DropdownItem>
										}
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
					</div>
				))
			}
			{
				showQuestionFormPopup &&
				<GDQuestionFormAdminPopup disclosureId={gd_id}
					question={selectedQuestion}
					saveCallback={onSave} />
			}
			{
				selectedQuestion.id > 0 && showDeleteConfirmation &&
				<ConfirmDialog
					open={showDeleteConfirmation}
					setOpen={setShowDeleteConfirmation}
					onConfirm={onDeleteConfirm}>
					<div className='text-center'>{t("ConfirmDelete.label")}</div>
				</ConfirmDialog>
			}
		</>
	);
};

export default withTranslation()(GDQuestionList);
